import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';

import { MultiSelect } from 'Components/MultiSelect/MultiSelect';
import { useMultiSelectFilters } from 'Hooks/SearchFilters/UseMultiSelectFilters';
import { getOptionsWithAggs } from 'Utils/SearchFilters/GetOptionsWithAggs';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import ApplyButton from '../ApplyButton/ApplyButton';
import { SEATS } from './SeatsFilter.constants';

import styles from './SeatsFilter.module.css';

type SeatsFilterProps = FilterControlBaseProps;

export const SeatsFilter = ({
  strings,
  locale,
  isPlpFiltersSeoEnabled,
  tenant,
  applyButton = false,
}: SeatsFilterProps) => {
  const { seats } = useAtomValue(aggregationsAtom);

  const { handleSelect, handleApply, listWithSelected } = useMultiSelectFilters(
    'seats',
    getOptionsWithAggs(SEATS, seats),
    strings,
    locale,
    isPlpFiltersSeoEnabled,
    tenant,
    undefined,
    applyButton,
  );

  return (
    <section className={styles.seatsFilter}>
      <MultiSelect
        groupName="seats"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={(id, checked) => {
          handleSelect(id, checked);
        }}
        dataTestId="seats-filter-list"
        applyButton={applyButton}
      />
      {applyButton && <ApplyButton handleApply={handleApply} ctaText={strings.apply} />}
    </section>
  );
};
